module.exports = __webpack_public_path__ + "b60190de060314ac3fd29822217d5c1d.svg";